import React from 'react';

import './RecurringBuyEditWhatsNext.scss';

import config from '../../../../config/config';
import ConfirmationExitBox from '../../ConfirmationExitBox';
import recurringCalendar from '../../../../assets/images/recurring-calendar.svg';
import dollarSignMonitor from '../../../../assets/images/dollar-sign-monitor.svg';
import sellDashboard from '../../../../assets/images/sell-dashboard.svg';

export const RecurringBuyEditWhatsNext = () => (
  <div className="recurring-buy-edit-whats-next-exit-container">
    <div>
      <div className="recurring-buy-edit-whats-next-exit-heading">
        What's next?
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-another-trade'}
            className={'e2e-confirm-another-trade'}
            heading={'View Your Automatic Transactions'}
            subHeading={'Set up or manage existing recurring transactions.'}
            image={recurringCalendar}
            exitLocation={`${config.url}/usis/transactions/automatic`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-one-time-trade'}
            className={'e2e-confirm-one-time-trade'}
            heading={'Make A One-Time Transaction'}
            subHeading={'Buy, sell, or exchange your investments.'}
            image={dollarSignMonitor}
            exitLocation={`${config.url}/usis/transactions/landing`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-view-dashboard'}
            className={'e2e-confirm-view-dashboard'}
            heading={'Go To Your Dashboard'}
            subHeading={'See your account balances and daily change.'}
            image={sellDashboard}
            exitLocation={`${config.url}/usis/my-accounts/dashboard`}
          />
        </div>
      </div>
    </div>
  </div>
);

export default RecurringBuyEditWhatsNext;
